module.exports = __webpack_public_path__ + "static/media/quick_guide_login2.61c5cd01.jpg";